export default __webpack_public_path__ + "static/media/Logo_Trust_NEOM@3x.295f6a29.png";